import {
    FETCH_POST_SUCCESS,
    FETCH_POST_MORE_SUCCESS
} from '../constants/ActionTypes';
import { POST_FEED_PER_PAGE } from '../constants/PostFeed';

const initialState = {
    loader: true,
    showDummy: false,
    postList: null,
    page: 1,
    hasMore: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_POST_SUCCESS:
            return {
                ...state,
                loader: false,
                showDummy: action.payload.length === 0 ? true : false,
                postList: action.payload,
                page: 1,
                hasMore: action.payload.length === POST_FEED_PER_PAGE
            }
        case FETCH_POST_MORE_SUCCESS:
            return {
                ...state,
                postList: [ ...(state.postList || []), ...action.payload ],
                page: state.page + 1,
                hasMore: action.payload.length === POST_FEED_PER_PAGE
            }
        default:
            return state;
    }
}
